<template>
  <div class="box11">
    <pageTitle title="真实学员评价" titleColor="#24375C" />
    <studentEvaluation
      :evaluateData="evaluateData"
      :styleData="styleData"
      @provideIndex="provideIndex"
      scrollColor="#C2C9FB"
      blockColor="#604BFA"
    />
    <!-- <div class="txt">
      * 资料来源：博学谷软件测试学科班主任老师与同学们的日常沟通截图
    </div> -->
    <previewImage
      ref="previewImage"
      :clickedIndex="clickedIndex"
      :isPreview="isPreview"
      type="img"
      :targetImg="evaluateData[this.cur].imgUrlList[this.clickedIndex].img"
      @close="close"
    />
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import previewImage from "../common/previewImage.vue";
import studentEvaluation from "../common/student-evaluation.vue";
export default {
  components: {
    pageTitle,
    studentEvaluation,
    previewImage,
  },

  data() {
    return {
      clickedIndex: 0,
      isPreview: false,
      cur: 0,
      evaluateData: [
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/dataAnalysis/box11/1.png"),
              id: 1,
            },
          ],
        },
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/dataAnalysis/box11/2.png"),
              id: 2,
            },
            {
              img: require("../../../assets/coursePage/dataAnalysis/box11/3.png"),
              id: 3,
            },
          ],
        },
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/dataAnalysis/box11/4.png"),
              id: 4,
            },
            {
              img: require("../../../assets/coursePage/dataAnalysis/box11/5.png"),
              id: 5,
            },
          ],
        },
        {
          imgUrlList: [
            {
              img: require("../../../assets/coursePage/dataAnalysis/box11/6.png"),
              id: 6,
            },
          ],
        },
      ],

      titleColor: "#3E4F48",

      styleData: {
        imgBorder: "border: 0.053333rem solid #C2C9FB;",
        imgHoverBorder: "border: 0.053333rem solid #604BFA;",
      },
    };
  },
  methods: {
    provideIndex(index, index1) {
      this.clickedIndex = index1;
      this.cur = index;
      this.isPreview = true;
    },
    close() {
      this.isPreview = false;
      this.clickedIndex = 0;
      this.cur = 0;
      // this.imageUrl = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.box11 {
  font-size: 4px;
  padding: 80px 0 88px;
  width: 100%;
  background: url("../../../assets/coursePage/dataAnalysis/box11/bgc2.png")
    no-repeat;
  background-position: top;
  background-size: cover;
  .txt {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #b9c8d9;
    line-height: 20px;
    text-align: center;
    margin-top: 70px;
  }
}
</style>
